import { OrganizationKeyName } from "../../../model/Organization";

export const GET_USER_TERM = "GET_USER_TERM";
export type GetUserTermAction = {
  type: typeof GET_USER_TERM;
  organization: OrganizationKeyName;
  userTermId: string;
};
export const getUserTermAction = (
  organization: OrganizationKeyName,
  userTermId: string
): GetUserTermAction => ({
  type: GET_USER_TERM,
  organization,
  userTermId,
});

export const GET_USER_TERM_FAIL = "GET_USER_TERM_FAIL";
export type GetUserTermFailAction = {
  type: typeof GET_USER_TERM_FAIL;
  organization: OrganizationKeyName;
  userTermId: string;
};

export const getUserTermFailAction = (
  organization: OrganizationKeyName,
  userTermId: string
): GetUserTermFailAction => ({
  type: GET_USER_TERM_FAIL,
  organization,
  userTermId,
});

export const GET_USER_TERM_SUCCESS = "GET_USER_TERM_SUCESS";
export type GetUserTermSuccessAction = {
  type: typeof GET_USER_TERM_SUCCESS;
  organization: OrganizationKeyName;
  userTermId: string;
  data: any;
};
export const getUserTermSuccessAction = (
  organization: OrganizationKeyName,
  userTermId: string,
  data: any
): GetUserTermSuccessAction => ({
  type: GET_USER_TERM_SUCCESS,
  organization,
  userTermId,
  data,
});
